import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { firstValueFrom, take } from 'rxjs';
import { RmsModule } from '@rms';
import { LedgerService, PromptService, RmsMessageService, lastValueFrom } from '@services';
import { RMS_PULLDOWN_DATA } from '../../../../../../custom-modules/rms-module/rms-pulldown/rms-pulldown.tokens';
import { RmsPulldownRef } from '../../../../../../custom-modules/rms-module/rms-pulldown/rms-pulldown-ref';

@Component({
  selector: 'app-period-detail',
  imports: [RmsModule],
  templateUrl: './period-detail.component.html',
  styleUrl: './period-detail.component.scss'
})
export class PeriodDetailComponent implements OnInit {
  Period: any;
  CanManage = false;
  History: any[] = [];
  Loading = true;
  Busy = false;

  constructor(
    @Inject(RMS_PULLDOWN_DATA) data: { Period: any; CanManage: boolean },
    private ref: RmsPulldownRef,
    private ledger: LedgerService,
    private prompt: PromptService,
    private message: RmsMessageService,
    private cdr: ChangeDetectorRef
  ) {
    this.Period = data.Period;
    this.CanManage = data.CanManage;
  }

  ngOnInit() { this.loadHistory(); }

  get IsClosed(): boolean { return this.Period?.Status === 'Closed'; }

  private async loadHistory() {
    try {
      this.History = await lastValueFrom(this.ledger.getPeriodHistory(this.Period.PeriodID)) || [];
    } catch (err: any) {
      this.message.error('Failed to load period history: ' + (err?.error?.error || err?.message || 'Unknown error'));
    } finally {
      this.Loading = false;
      this.cdr.detectChanges();
    }
  }

  async changeStatus() {
    const target = this.IsClosed ? 'Open' : 'Closed';
    const openJournals = this.Period.OpenJournals
      ? ` ${this.Period.OpenJournals} draft or in-review journal(s) are dated in this period; they won't be submittable while it is closed.`
      : '';
    const { closed$ } = this.prompt.open({
      promptText: this.IsClosed
        ? `Reopen ${this.Period.PeriodName}? Journals dated in it can be submitted again.`
        : `Close ${this.Period.PeriodName}?${openJournals}`,
      promptInput: 'textarea',
      inputLabel: this.IsClosed ? 'Reason for reopening' : 'Reason for closing',
      inputRequired: true,
      buttons: [{ label: this.IsClosed ? 'Reopen period' : 'Close period', value: true, buttonClass: this.IsClosed ? 'btn-bg-green' : 'btn-bg-red' }]
    });
    const result: any = await firstValueFrom(closed$.pipe(take(1)));
    const reason = result?.buttonValue ? String(result.inputValue || '').trim() : '';
    if (!result?.buttonValue) return;
    if (!reason) { this.message.warn('A reason is required.'); return; }

    this.Busy = true;
    try {
      const updated = await lastValueFrom(this.ledger.setPeriodStatus(this.Period.PeriodID, target, reason));
      this.Period = { ...this.Period, ...updated };
      this.message.success(`${this.Period.PeriodName} is now ${target === 'Open' ? 'open' : 'closed'}.`);
      await this.loadHistory();
    } catch (err: any) {
      this.message.error(err?.error?.error || err?.message || 'Could not change the period.');
    } finally {
      this.Busy = false;
      this.cdr.detectChanges();
    }
  }

  close() { this.ref.close(true); }
}
